(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hr-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector("[data-hr-hero]");
    if (!root) return;
    const parent = root.querySelector(".hr-hero__slides");
    const deckEl = root.querySelector("[data-hr-hero-deck]");
    if (!parent || !deckEl) return;

    let deck = [];
    try {
      deck = JSON.parse(deckEl.textContent);
    } catch (err) {
      return;
    }
    if (!deck.length) return;

    const first = parent.querySelector(".hr-hero__img");
    const firstImg = first && first.querySelector("img");

    const markLoaded = (picture) => {
      const img = picture.querySelector("img");
      if (!img) return;
      const done = () => picture.classList.add("is-loaded");
      if (img.complete && img.naturalWidth) done();
      else img.addEventListener("load", done, { once: true });
      img.addEventListener("error", done, { once: true });
    };

    if (first) markLoaded(first);

    const srcset = (map, widths) =>
      widths.map((w) => `${map[String(w)]} ${w}w`).join(", ");

    const fillPicture = (picture, item, eager) => {
      const avif = picture.querySelector('source[type="image/avif"]');
      const webp = picture.querySelector('source[type="image/webp"]');
      const img = picture.querySelector("img");
      avif.srcset = srcset(item.avif, [900, 1600]);
      webp.srcset = srcset(item.webp, [900, 1600]);
      img.srcset = srcset(item.jpg, [900, 1600, 2050]);
      img.sizes = "100vw";
      img.src = item.jpg["2050"];
      img.alt = item.alt;
      img.width = 2050;
      img.height = 2400;
      img.decoding = "async";
      if (eager) {
        img.loading = "eager";
        img.setAttribute("fetchpriority", "high");
      } else {
        img.loading = "eager";
        img.removeAttribute("fetchpriority");
      }
    };

    const makePicture = (item) => {
      const picture = first.cloneNode(true);
      picture.classList.remove("is-active", "is-loaded");
      fillPicture(picture, item, false);
      return picture;
    };

    const rest = deck.slice(1);
    for (let i = rest.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const tmp = rest[i];
      rest[i] = rest[j];
      rest[j] = tmp;
    }
    const order = [deck[0], ...rest];

    const prefetch = (item) => {
      if (!item || item._prefetched) return;
      item._prefetched = true;
      const link = document.createElement("link");
      link.rel = "prefetch";
      link.as = "image";
      link.href = item.webp["1600"];
      document.head.appendChild(link);
    };

    prefetch(order[1]);

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (order.length < 2) return;

    let n = 0;
    let current = first;
    setInterval(function () {
      const nextIndex = (n + 1) % order.length;
      const item = order[nextIndex];
      const incoming = makePicture(item);
      parent.appendChild(incoming);
      const img = incoming.querySelector("img");
      const reveal = () => {
        incoming.classList.add("is-active", "is-loaded");
        if (current && current !== incoming) {
          current.classList.remove("is-active");
          const outgoing = current;
          window.setTimeout(() => outgoing.remove(), 1200);
        }
        current = incoming;
        n = nextIndex;
        prefetch(order[(nextIndex + 1) % order.length]);
      };
      const go = () => {
        if (img.decode) img.decode().then(reveal).catch(reveal);
        else reveal();
      };
      if (img.complete && img.naturalWidth) go();
      else img.addEventListener("load", go, { once: true });
    }, 6500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
